import { Phone, MessageSquare } from "lucide-react";
import { useSettings } from "../../context/SettingsContext";
import { useLang } from "../../i18n/LangContext";
import { formatPhone } from "../../lib/api";

export const CallButton = ({ testId, className = "", showNumber = false }) => {
  const { settings } = useSettings();
  const { t } = useLang();
  if (!settings.phone) {
    return (
      <span
        data-testid={testId}
        aria-disabled="true"
        title={t("cta.phoneSoon")}
        className={`btn-yellow opacity-50 cursor-not-allowed ${className}`}
      >
        <Phone className="h-5 w-5" aria-hidden="true" /> {t("cta.callNow")}
      </span>
    );
  }
  return (
    <a data-testid={testId} href={`tel:${settings.phone}`} className={`btn-yellow ${className}`}>
      <Phone className="h-5 w-5" aria-hidden="true" />
      {t("cta.callNow")}
      {showNumber && <span className="font-mono normal-case tracking-normal">{formatPhone(settings.phone)}</span>}
    </a>
  );
};

export const TextButton = ({ testId, className = "" }) => {
  const { settings } = useSettings();
  const { t } = useLang();
  if (!settings.phone) return null;
  return (
    <a data-testid={testId} href={`sms:${settings.phone}`} className={`btn-ghost ${className}`}>
      <MessageSquare className="h-5 w-5" aria-hidden="true" /> {t("cta.textUs")}
    </a>
  );
};

export const PhoneSoonNote = ({ testId }) => {
  const { settings } = useSettings();
  const { t } = useLang();
  if (settings.phone) return null;
  return <p data-testid={testId} className="text-sm text-gray-400">{t("cta.phoneSoon")}</p>;
};
